<div class="container-fluid p-4">
  <div class="row">
    <div class="col-12">
      <div class="main-content mb-4">
        <div class="content">
          <ng-container *ngIf="isLoading; else showContent">
            <div class="app-spinner">
              <mat-spinner diameter="60"></mat-spinner>
            </div>
          </ng-container>

          <ng-template #showContent>
            <ng-container *ngIf="userDetail; else noUserMessage">
              <h1>
                Welcome back, {{ userDetail.first_name }}
                {{ userDetail.last_name }} !
              </h1>
            </ng-container>
            <ng-template #noUserMessage>
              <h1>Welcome!</h1>
              <span>We couldn't find your profile details. Please check your
                account settings.</span>
            </ng-template>
          </ng-template>
          <span>Track your progress and stay on top of your career preparation
            journey.</span>
        </div>
      </div>

      <ng-container *ngIf="
          currentSubscription?.product_name ===
            StudentsSubscriptionPlan.FREE_TRIAL &&
            currentSubscription?.product_price ===
              StudentsSubscriptionPlan.PRICE_VALUE;
          else showPriceMessage
        ">
        <div class="upgrade-banner trial2">
          <div class="banner-left">
            <div class="icon-box trial">
              <i class="bi bi-stars"></i>
            </div>
            <div>
              <h4 class="practise">Start Your Free AI Practise</h4>
              <p>
                Practice AI interviews and mock tests included in your free
                trial.
              </p>
            </div>
          </div>

          <ng-container *ngIf="completedFeatures.length; else showBtn">
            <div class="btn-action">
              <ng-container *ngFor="let feature of completedFeatures">
                <span class="btn-upgrade success me-3 disabled">
                  <i class="bi" [ngClass]="{
                      'bi-journal-check': feature === 'AI Mock Test',
                      'bi-mic-fill': feature === 'AI Interview Practice',
                    }"></i>
                  {{ feature }}
                  <i class="bi bi-check-circle-fill ms-1"></i>
                </span>
              </ng-container>

              <button *ngFor="let feature of pendingFeatures" class="btn-upgrade trial me-3" [routerLink]="
                  feature === 'AI Interview Practice'
                    ? '/student-dashboard/ai-interview-dashboard'
                    : '/student-dashboard/placement-prep'
                ">
                <i class="bi" [ngClass]="{
                    'bi-mic-fill': feature === 'AI Interview Practice',
                    'bi-journal-check': feature === 'AI Mock Test',
                  }"></i>
                {{
                feature === "AI Interview Practice"
                ? "Start AI Interview"
                : "Take a Mock Test"
                }}
              </button>
            </div>
          </ng-container>

          <ng-template #showBtn>
            <div class="btn-action">
              <button class="btn-upgrade trial me-3" [routerLink]="'/student-dashboard/ai-interview-dashboard'">
                <i class="bi bi-mic-fill"></i> Start AI Interview
              </button>
              <button class="btn-upgrade trial" [routerLink]="'/student-dashboard/placement-prep'">
                <i class="bi bi-journal-check"></i> Take a Mock Test
              </button>
            </div>
          </ng-template>
        </div>

        <ng-container *ngIf="completedFeatures.length">
          <div class="upgrade-banner font-name">
            <div class="banner-left">
              <div class="icon-box">
                <i class="bi bi-stars"></i>
              </div>
              <div>
                <h4 class="practise">Ready to take your practice further?</h4>
                <p>
                  Upgrade to unlock full-length interviews, mock tests and
                  advanced AI feedback.
                </p>
              </div>
            </div>

            <button class="upgrade-btn btn-upgrade" [routerLink]="'/student-dashboard/upgrade-plan'">
              <i class="bi bi-gem"></i> Upgrade
            </button>
          </div>
        </ng-container>
      </ng-container>

      <ng-template #showPriceMessage>
        <div class="plan-limit-box d-flex align-items-center justify-content-between" *ngIf="hasLimitOver">
          <div class="d-flex align-items-start gap-3">
            <div class="icon-wrapper">
              <i class="bi bi-exclamation-triangle-fill"></i>
            </div>
            <div>
              <h5 class="mb-1">You've reached a plan limit!</h5>

              <div class="features d-flex gap-3 mt-2">
                <span *ngFor="let feature of upgradeFeatures">
                  <i class="bi" [ngClass]="{
                      'bi-journal-check': feature === 'AI Mock Test',
                      'bi-mic-fill': feature === 'AI Interview Practice',
                      'bi-book': feature === 'Professional Courses',
                      'bi-camera-video': feature === 'Mentor Session',
                    }"></i>
                  {{ feature }}
                </span>
                <p class="mb-0 mt-1 small-text font-name">
                  Upgrade your plan to continue using these features!
                </p>
              </div>
            </div>
          </div>

          <button class="upgrade btn-upgrade" [routerLink]="'/student-dashboard/upgrade-plan'">
            <i class="bi bi-gem"></i> Upgrade
          </button>
        </div>
      </ng-template>

      <!-- <div class="dashboard-grid mt-4 mb-3">
        <ng-container *ngIf="isStatsLoading; else pageStatsContent">
          <div class="app-spinner">
            <mat-spinner diameter="60"></mat-spinner>
          </div>
        </ng-container>

        <ng-template #pageStatsContent>
          <ng-container *ngIf="students.length > 0; else showStatsMessage">
            <div class="stat-card" *ngFor="let studentData of students" (click)="navigateTo(studentData)"
              [class.clickable]="!isFreeTrial">
              <p class="free-trial-overlay" *ngIf="isFreeTrial">
                <span><i class="bi bi-lock"></i></span>
                Upgrade to unlock full access!
              </p>

              <div [class.blur-ui]="isFreeTrial">
                <div class="stats-header">
                  <div class="icon-wrapper" [ngClass]="studentData.color">
                    <mat-icon>{{ studentData.icon }}</mat-icon>
                  </div>
                  <h4>{{ studentData.title }}</h4>
                </div>

                <ng-container *ngIf="studentData.used !== undefined">
                  <div class="stats-body">
                    <ng-container *ngIf="studentData.showRemainingOnly">
                      <p class="sub-texts">{{ studentData.used || 0 }}</p>
                      <span class="remaining m-0">
                        <i class="bi bi-calender"></i>
                        {{ studentData.text || "N/A" }}</span>
                    </ng-container>

                    <ng-container *ngIf="studentData.showRemainingQuizOnly">
                      <p class="sub-quiz">{{ studentData.used || 0 }}</p>
                      <span class="remaining m-0">
                        <i class="bi bi-calender"></i>
                        {{ studentData.text || "N/A" }}</span>
                    </ng-container>

                    <ng-container *ngIf="
                        !studentData.showRemainingOnly &&
                        !studentData.showRemainingQuizOnly
                      ">
                      <h2>
                        {{ studentData.used || 0 }}
                        <span>/ {{ studentData.total || 0 }}</span>
                        <span> {{ studentData.text || "N/A" }}</span>
                      </h2>
                      <div class="mini-progress">
                        <div class="mini-progress-bar" [style.width.%]="getProgressPercent(studentData)"
                          [style.background-color]="
                            getProgressColor(studentData)
                          "></div>
                        <span class="mini-progress-text"></span>
                      </div>
                      <p class="sub-text">
                        {{ studentData.remaining || 0 }}
                        {{ studentData.subtext }} Remaining
                      </p>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <ng-template #showStatsMessage>
            <p class="text-center font-name">not available</p>
          </ng-template>
        </ng-template>
      </div> -->
    </div>
  </div>
  <!-- 
  <ng-container *hasPermission="PermissionForStudents.COURSE_VIEW">
    <div class="row" *ngIf="!isFreeTrial">
      <div class="course-name mt-5 mb-2 d-flex justify-content-between">
        <h5>Continues Learning</h5>
      </div>

      <ng-container *ngIf="isCourseLoading; else pageContent">
        <div class="app-spinner">
          <mat-spinner diameter="60"></mat-spinner>
        </div>
      </ng-container>
      <ng-template #pageContent>
        <ng-container *ngIf="myCourses.length > 0; else showCourseMessage">
          <div class="row">
            <div class="col-12 col-sm-6 col-md-4 mb-4" *ngFor="let course of myCourses | slice: 0 : 6">
              <div class="card">
                <div class="card-top" [ngClass]="{ 'no-thumbnail': !course.course_thumbnail }" [ngStyle]="
                    course.course_thumbnail
                      ? {
                          'background-image':
                            'url(' + course.course_thumbnail + ')',
                        }
                      : {}
                  "></div>
                <div class="card-body">
                  <h5 class="card-title text-truncate" matTooltip="{{ course.course_title }}">
                    {{ course.course_title || "N/A" }}
                  </h5>
                  <span>Progress</span>
                  <div class="mini-progress">
                    <div class="mini-progress-bar" [style.width.%]="course.progress_percentage"></div>
                    <span class="mini-progress-text">
                      {{
                      course.progress_percentage % 1 === 0
                      ? (course.progress_percentage | number: "1.0-0")
                      : (course.progress_percentage | number: "1.0-2")
                      }}
                      %
                    </span>
                  </div>
                  <div class="stats mb-3">
                    <i class="bi bi-book"></i> {{ course.total_units }} lessons
                    <i class="bi bi-lightbulb"></i>
                    {{ course.total_published_quizzes }} quizzes
                  </div>
                  <ng-container *ngIf="
                      course.status === StudentEnrollmentStatus.ENROLLED ||
                        course.status === StudentEnrollmentStatus.IN_PROGRESS;
                      else showComplete
                    ">
                    <button class="btn-add w-100 mt-2" (click)="goToCourseDescriptionPage(course.course_id)">
                      Continue
                      <i class="bi bi-arrow-right-circle"></i>
                    </button>
                  </ng-container>

                  <ng-template #showComplete>
                    <button class="btn-add w-100 mt-2" (click)="goToCourseDescriptionPage(course.course_id)">
                      View
                      <i class="bi bi-eye"></i>
                    </button>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #showCourseMessage>
          <p class="text-center mt-5 font-name">No courses enrolled</p>
        </ng-template>
      </ng-template>
    </div>
  </ng-container> -->

      <div class="placement-cards">
        <div class="placement-card jobs"
        [routerLink]="['/student-dashboard/jobs']">
          <div class="icon-box">
            <span class="material-icons">business_center</span>
          </div>
          <h3>Jobs</h3>
          <p>Find & apply</p>
        </div>

        <div class="placement-card mock-test"
        [routerLink]="['/student-dashboard/placement-prep']">
          <div class="icon-box">
            <span class="material-icons">assignment</span>
          </div>
          <h3>Mock Tests</h3>
          <p>Practice daily</p>
        </div>

        <div class="placement-card mock-interview mb-2"
          [routerLink]="['/student-dashboard/ai-interview-dashboard']">
          <div class="icon-box">
            <span class="material-icons">videocam</span>
          </div>
          <h3>Mock Interview</h3>
          <p>AI practice</p>
        </div>

        <div class="placement-card resume"
          [routerLink]="['/student-dashboard/resume']">
          <div class="icon-box">
            <span class="material-icons">description</span>
          </div>
          <h3>Resume Builder</h3>
          <p>ATS-ready</p>
        </div>

        <div class="placement-card roadmap"
          [routerLink]="['/student-dashboard/my-roadmap']">
          <div class="icon-box">
            <span class="material-icons">menu_book</span>
          </div>
          <h3>Roadmap</h3>
          <p>Plan career</p>
        </div>
      </div>
  <div class="recommended-jobs-container mb-4">
    <div class="recommended-jobs-header d-flex justify-content-between align-items-center flex-wrap gap-3">
      <div class="d-flex align-items-center gap-3">
        <div class="header-icon-box">
          <i class="bi bi-stars"></i>
        </div>
        <div>
          <h3 class="mb-0">Recommended jobs for you</h3>
          <p class="mb-0 text-muted">Complete your profile to get personalised matches</p>
        </div>
      </div>
      <a routerLink="/student-dashboard/jobs" [queryParams]="{ tab: 'recommended' }" class="view-all-link">View all
        recommended jobs <i class="bi bi-chevron-right"></i></a>
    </div>

    <ng-container *ngIf="isRecommendedJobsLoading; else recommendedContent">
      <div class="app-spinner mt-4">
        <mat-spinner diameter="60"></mat-spinner>
      </div>
    </ng-container>

    <ng-template #recommendedContent>
      <ng-container *ngIf="recommendedJobs.length > 0; else noRecommendedJobs">
        <div class="card-container mt-4">
          <div class="job-card" *ngFor="let job of recommendedJobs">
            <!-- Top -->
            <div class="job-top">
              <div class="company-info">
                <div class="company-logo">
                  <img *ngIf="job.company_logo; else noLogo" [src]="job.company_logo" alt="Company Logo"
                    class="company-img" />
                  <ng-template #noLogo>
                    <i class="bi bi-briefcase"></i>
                  </ng-template>
                </div>

                <div>
                  <p class="company-name" [matTooltip]="job.company_name">
                    {{ truncateText(job.company_name, 25) }}
                  </p>
                  <h3 [matTooltip]="job.job_title">
                    {{ truncateText(job.job_title, 35) }}
                  </h3>
                </div>
              </div>
              <i class="bi" [ngClass]="
                  job.is_saved
                    ? 'bi-bookmark-fill saved-bookmark'
                    : 'bi-bookmark'
                " (click)="toggleSaveJob(job)"></i>
            </div>

            <div class="job-tags">
              <ng-container *ngIf="job.job_type">
                <span>{{ job.job_type }}</span>
              </ng-container>

              <ng-container *ngIf="job.work_mode">
                <span class="active-tag">{{ job.work_mode }}</span>
              </ng-container>

              <ng-container *ngIf="job.locations.length">
                <span *ngFor="let location of job.locations"><i class="bi bi-geo-alt"></i> {{ location }}</span>
              </ng-container>
            </div>

            <div class="divider"></div>

            <div class="job-bottom">
              <ng-container *ngIf="job.number_of_openings">
                <div>
                  <i class="bi bi-people"></i>
                  {{ job.number_of_openings || "0" }} openings
                </div>
              </ng-container>

              <ng-container *ngIf="job.experience_level">
                <div>
                  <i class="bi bi-clock"></i>
                  {{ job.experience_level }}
                </div>
              </ng-container>

              <ng-container *ngIf="getDaysAgo(job.published_at)">
                <div>
                  <i class="bi bi-calendar3"></i>
                  {{ getDaysAgo(job.published_at) }}
                </div>
              </ng-container>
            </div>

            <button class="view-btn" (click)="goToJobsDetailPage(job.job_id)">
              View details
            </button>
          </div>
        </div>
      </ng-container>

      <ng-template #noRecommendedJobs>
        <div class="recommended-jobs-content text-center mt-3">
          <div class="profile-icon-circle mx-auto mb-3">
            <i class="bi bi-person-plus"></i>
          </div>
          <h4>Get personalised job recommendations</h4>
          <p class="text-muted mx-auto" style="max-width: 550px;">
            Add your details, career preferences and resume so we can match you with the right roles.
          </p>
          <button class="btn btn-complete-profile mt-2" routerLink="/student-dashboard/profile">
            Complete your profile <i class="bi bi-arrow-right ms-2"></i>
          </button>
        </div>
      </ng-template>
    </ng-template>
  </div>
    <app-featured-mock-test></app-featured-mock-test>
    <app-featured-mock-interview></app-featured-mock-interview>
  <ng-container *ngIf="isApplicationLoading; else pageContentApplication">
    <div class="app-spinner">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  </ng-container>
  <ng-template #pageContentApplication>
    <ng-container *ngIf="jobData.length > 0; else showApplicationMessage">
      <div class="applications-page">
        <h1>Your Job Applications</h1>
        <span>Track progress at a glance</span>

        <div class="application-card mb-4" *ngFor="let application of jobData">
          <div class="app-card-top">
            <div class="company-section">
              <div class="company-logo">
                <img *ngIf="application.company_logo" [src]="application.company_logo" alt="Company Logo"
                  class="img-fluid logo" />
                <i *ngIf="!application.company_logo" class="bi bi-robot"></i>
              </div>

              <div>
                <p class="company-name">{{ application.company_name }}</p>
                <h2 class="job-role">{{ application.job_title }}</h2>
                <p class="applied-date">
                  Applied {{ application.applied_at | date: "mediumDate" }}
                </p>
              </div>
            </div>

            <ng-container *ngIf="showAssessmentButton(application)">
              <button class="action-btn" (click)="openAssessment(application)">
                Start Assessment
              </button>
            </ng-container>

            <ng-container *ngIf="showInterviewButton(application)">
              <button class="action-btn" (click)="openInterview(application)">
                Start Interview
              </button>
            </ng-container>

            <ng-container *ngIf="application.status === 'shortlisted'">
              <div class="status-badge shortlisted">
                <i class="bi bi-patch-check-fill"></i>
                Shortlisted
              </div>
            </ng-container>
          </div>

          <div class="timeline">
            <div class="step completed">
              <div class="step-circle">
                <i class="bi bi-check"></i>
              </div>

              <div class="step-content">
              <h4>Applied</h4>
              <p>Submitted</p>
              </div>
            </div>

            <ng-container *ngIf="showAssessment(application)">
              <div class="line"></div>

              <div class="step" [ngClass]="{
                  completed: application.assessment.completed_at,
                  active:
                    application.assessment.status === 'pending' &&
                    !application.assessment.completed_at,
                }">
                <div class="step-circle">
                  <i class="bi" [ngClass]="{
                      'bi-check': application.assessment.completed_at,
                      'bi-clock': !application.assessment.completed_at,
                    }"></i>
                </div>

                <div class="step-content">
                <h4>Assessment</h4>
                <p>
                  {{
                  application.assessment.completed_at
                  ? "Completed"
                  : "Pending"
                  }}
                </p>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="showInterview(application)">
              <div class="line"></div>

              <div class="step" [ngClass]="{
                  completed: application.interview.completed_at,

                  active:
                    application.interview.status === 'pending' &&
                    (application.assessment.status === 'not_assigned' ||
                      application.assessment.completed_at),

                  locked:
                    application.interview.status === 'pending' &&
                    application.assessment.status !== 'not_assigned' &&
                    !application.assessment.completed_at,
                }">
                <div class="step-circle">
                  <i class="bi" [ngClass]="{
                      'bi-check': application.interview.completed_at,
                      'bi-clock':
                        application.interview.status === 'pending' &&
                        (application.assessment.status === 'not_assigned' ||
                          application.assessment.completed_at),
                      'bi-lock':
                        application.interview.status === 'pending' &&
                        application.assessment.status !== 'not_assigned' &&
                        !application.assessment.completed_at,
                    }"></i>
                </div>

                <div class="step-content">
                <h4>Interview</h4>
                <p>
                  {{
                  application.interview.completed_at
                  ? "Completed"
                  : application.assessment.status !== "not_assigned" &&
                  !application.assessment.completed_at
                  ? "Waiting for Assessment"
                  : "Pending"
                  }}
                </p>
                </div>
              </div>
            </ng-container>

            <div class="line"></div>

            <div class="step" [ngClass]="{
                completed: application.status === 'selected' || isAllStepsCompleted(application),
                active: application.status === 'shortlisted' && !isAllStepsCompleted(application),
                locked:
                  (application.status === 'applied' ||
                  application.status === 'in_progress') && !isAllStepsCompleted(application),
              }">
              <div class="step-circle">
                <i class="bi" [ngClass]="{
                    'bi-check': application.status === 'selected',
                    'bi-clock': application.status === 'shortlisted' || isAllStepsCompleted(application),
                    'bi-lock':
                      (application.status === 'applied' ||
                      application.status === 'in_progress') && !isAllStepsCompleted(application),
                  }"></i>
              </div>

              <div class="step-content">
              <h4>Result</h4>
              <p>{{ (isAllStepsCompleted(application) && application.status !== 'selected' && application.status !==
                'shortlisted') ? 'Thank you for applying' : (application.status | titlecase) }}</p>
              </div>
            </div>
          </div>
          <ng-container *ngIf="application.status === 'shortlisted'">
            <div class="short mt-4">
              You have been shortlisted for
              {{ application.job_title }}
              at
              {{ application.company_name }}. The recruiter will contact you
              shortly.
            </div>
          </ng-container>

          <ng-container
            *ngIf="isAllStepsCompleted(application) && application.status !== 'shortlisted' && application.status !== 'selected'">
            <div class="message-box mt-4">
              <div class="message-title">
                <i class="bi bi-envelope"></i> Thank you for applying!
              </div>
              <p>Your application will be reviewed, and the result will be shared with you via email <strong>within 2
                  business days</strong>. If you're shortlisted, our hiring team will get in touch with you.</p>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="text-center mb-3 font-name" *ngIf="page < totalPages">
        <button class="btn-add" (click)="loadMore()" [disabled]="isApplicationLoading">
          <ng-container *ngIf="isApplicationLoading; else showBtn">
            <span class="spinner-border spinner-border-sm"></span> Loading...
          </ng-container>
          <ng-template #showBtn>Load More</ng-template>
        </button>
      </div>
    </ng-container>
    <ng-template #showApplicationMessage>
      <div class="dashboard-empty-state">
        <div class="dashboard-empty-icon">
          <i class="bi bi-folder-x"></i>
        </div>
        <h3 class="font-name dashboard-empty-title">No Jobs Applied Yet</h3>
        <p class="dashboard-empty-subtitle">You haven't applied to any jobs yet. Browse available jobs and start your
          career journey.</p>
        <button class="dashboard-empty-btn" routerLink="/student-dashboard/jobs">Browse Jobs</button>
      </div>
    </ng-template>
  </ng-template>
</div>